module.exports = __webpack_public_path__ + "media/components/star-rating/static/white/9-a382a2403c6ddd3a91695758f4f3da74.svg";